import React from "react";
import { useNavigate } from "react-router-dom";
import { logo_text, logo } from "../../../config";

const SalesLeftSidebar = () => {
  const navigate = useNavigate();

  return (
    <>
      <aside
        id="layout-menu"
        className="layout-menu menu-vertical  bg-menu-theme "
      >
        <div className="app-brand demo ">
          <a onClick={() => navigate("/saleshome")} className="app-brand-link ">
            <span className="app-brand-logo demo">
              <img className="h-8" src={logo} />
            </span>
            <span className="app-brand-text demo menu-text fw-bold ">
              <img className="h-8" src={logo_text} />
            </span>
          </a>
          <a className="layout-menu-toggle menu-link text-large ms-auto">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.4854 4.88844C11.0081 4.41121 10.2344 4.41121 9.75715 4.88844L4.51028 10.1353C4.03297 10.6126 4.03297 11.3865 4.51028 11.8638L9.75715 17.1107C10.2344 17.5879 11.0081 17.5879 11.4854 17.1107C11.9626 16.6334 11.9626 15.8597 11.4854 15.3824L7.96672 11.8638C7.48942 11.3865 7.48942 10.6126 7.96672 10.1353L11.4854 6.61667C11.9626 6.13943 11.9626 5.36568 11.4854 4.88844Z"
                fill="currentColor"
                fillOpacity="0.6"
              />
              <path
                d="M15.8683 4.88844L10.6214 10.1353C10.1441 10.6126 10.1441 11.3865 10.6214 11.8638L15.8683 17.1107C16.3455 17.5879 17.1192 17.5879 17.5965 17.1107C18.0737 16.6334 18.0737 15.8597 17.5965 15.3824L14.0778 11.8638C13.6005 11.3865 13.6005 10.6126 14.0778 10.1353L17.5965 6.61667C18.0737 6.13943 18.0737 5.36568 17.5965 4.88844C17.1192 4.41121 16.3455 4.41121 15.8683 4.88844Z"
                fill="currentColor"
                fillOpacity="0.38"
              />
            </svg>
          </a>
        </div>
        <div className="menu-inner-shadow"></div>
        <ul className="menu-inner py-1">
          {/* Manage Sales Type */}
          <li className=" menu-item">
            <a className="menu-link menu-toggle">
              <i className="menu-icon tf-icons mdi mdi-account-tie"></i>
              <div data-i18n="Manage Sales Type">Manage Sales Type</div>
            </a>
            <ul className="menu-sub">
              <li className="cursor-pointer menu-item">
                <a
                  onClick={() => {
                    navigate("/addsalestype");
                  }}
                  className="menu-link"
                >
                  <div data-i18n="Add Sales Type">Add Sales Type</div>
                </a>
              </li>
            </ul>
            <ul className="menu-sub">
              <li className="cursor-pointer menu-item">
                <a
                  onClick={() => {
                    navigate("/viewsalestype");
                  }}
                  className="menu-link"
                >
                  <div data-i18n="View Sales Types">View Sales Types</div>
                </a>
              </li>
            </ul>
          </li>

          {/* Manage employee */}
          <li className=" menu-item">
            <a className="menu-link menu-toggle">
              <i className="menu-icon tf-icons mdi mdi-account-multiple"></i>
              <div data-i18n="Manage Employee">Manage Employee</div>
            </a>
            <ul className="menu-sub">
              <li className="cursor-pointer menu-item">
                <a
                  onClick={() => {
                    navigate("/addemployee");
                  }}
                  className="menu-link"
                >
                  <div data-i18n="Add Employee">Add Employee</div>
                </a>
              </li>
            </ul>
            <ul className="menu-sub">
              <li className="cursor-pointer menu-item">
                <a
                  onClick={() => {
                    navigate("/viewemployees");
                  }}
                  className="menu-link"
                >
                  <div data-i18n="View Employees">View Employees</div>
                </a>
              </li>
            </ul>
          </li>

          {/* Manage Lead Profile */}
          <li className=" menu-item">
            <a className="menu-link menu-toggle">
              <i className="menu-icon tf-icons mdi mdi mdi-account-group"></i>
              <div data-i18n="Manage Lead Profile">Manage Lead Profile</div>
            </a>
            <ul className="menu-sub">
              <li className="cursor-pointer menu-item">
                <a
                  onClick={() => {
                    navigate("/addleadprofile");
                  }}
                  className="menu-link"
                >
                  <div data-i18n="Add Lead Profile">Add Lead Profile</div>
                </a>
              </li>
            </ul>
            <ul className="menu-sub">
              <li className="cursor-pointer menu-item">
                <a
                  onClick={() => {
                    navigate("/viewleadprofiles");
                  }}
                  className="menu-link"
                >
                  <div data-i18n="View Lead Profiles">View Lead Profiles</div>
                </a>
              </li>
            </ul>
            <ul className="menu-sub">
              <li className="cursor-pointer menu-item">
                <a
                  onClick={() => {
                    navigate("/completedleads");
                  }}
                  className="menu-link"
                >
                  <div data-i18n="Completed Leads">Completed Leads</div>
                </a>
              </li>
            </ul>
          </li>

          {/* Manage Token Coupon */}
          <li className=" menu-item">
            <a className="menu-link menu-toggle">
              <i className="menu-icon tf-icons mdi mdi-ticket"></i>
              <div data-i18n="Manage Token Coupon">Manage Token Coupon</div>
            </a>
            <ul className="menu-sub">
              <li className="cursor-pointer menu-item">
                <a
                  onClick={() => {
                    navigate("/addrefferal");
                  }}
                  className="menu-link"
                >
                  <div data-i18n="Add Token Coupon">Add Token Coupon</div>
                </a>
              </li>
            </ul>
            <ul className="menu-sub">
              <li className="cursor-pointer menu-item">
                <a
                  onClick={() => {
                    navigate("/viewrefferals");
                  }}
                  className="menu-link"
                >
                  <div data-i18n="View Token Coupon">View Token Coupon</div>
                </a>
              </li>
            </ul>
          </li>

          {/* Manage Query */}
          {/* <li className=" menu-item">
            <a className="menu-link menu-toggle">
              <i className="menu-icon tf-icons mdi mdi-information"></i>
              <div data-i18n="Manage Query">Manage Query</div>
            </a>
      
            <ul className="menu-sub">
              <li className="cursor-pointer menu-item">
                <a
                  onClick={() => {
                    navigate("/viewqueries");
                  }}
                  className="menu-link"
                >
                  <div data-i18n="View Queries">View Queries</div>
                </a>
              </li>
            </ul>
          </li> */}
        </ul>
      </aside>
    </>
  );
};

export default SalesLeftSidebar;
